var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91658 12.25V11.0833C9.91658 10.4645 9.67075 9.871 9.23317 9.43342C8.79558 8.99583 8.20209 8.75 7.58325 8.75H2.91659C2.29775 8.75 1.70425 8.99583 1.26667 9.43342C0.829085 9.871 0.583252 10.4645 0.583252 11.0833V12.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25008 6.41667C6.53875 6.41667 7.58342 5.372 7.58342 4.08333C7.58342 2.79467 6.53875 1.75 5.25008 1.75C3.96142 1.75 2.91675 2.79467 2.91675 4.08333C2.91675 5.372 3.96142 6.41667 5.25008 6.41667Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4167 12.2501V11.0834C13.4164 10.5664 13.2443 10.0642 12.9275 9.65561C12.6108 9.24701 12.1673 8.95518 11.6667 8.82593"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 1.82593C9.83516 1.95444 10.28 2.24634 10.5977 2.65561C10.9154 3.06488 11.0878 3.56824 11.0878 4.08634C11.0878 4.60444 10.9154 5.10781 10.5977 5.51708C10.28 5.92635 9.83516 6.21825 9.33325 6.34676"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.f98915b5d672d5e6a2060750edca78f1.svg";
export { ForwardRef as ReactComponent };